import React, {Component} from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';

// Custom Components
import AuthStepper from '../Stepper/AuthStepper';

// Steps
import LoginStep from '../Form/Steps/LoginStep';
import SignUpStep from '../Form/Steps/SignUpStep';
import PaymentStep from '../Form/Steps/PaymentStep';
import VerificationStep from '../Form/Steps/VerificationStep';
import ConfirmStep from '../Form/Steps/ConfirmStep';
import PasswordResetStep from '../Form/Steps/PasswordResetStep';

// Utilities
import { required, isEmail, composeValidators, isNum, passwordsMustMatch } from '../Form/validation';

class BookingFlowScreen extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            currentDialog: 'login',
            finalStep: null,
            formValues: null,
            stepToShow: 0,
        }
    }
    
    componentDidMount() {
        // console.log('USERID @ CDM-BFS', this.props.userId);
        if (this.props.userId){
            // this.props.getClientData(this.props.userId);
            this.props.getCreditAmount(this.props.userId);
        }
        if (!this.props.userId) {
            this.props.initAuthFlowRequiredStatus();
        }
    }

    handleChooseAuthDialog = (choice) => {
        this.setState({
            currentDialog: choice
        });
        this.props.setCurrentDialog(choice);
        // console.log('called set current dialog...');
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.errorData !== nextProps.errorData){
            // console.log('changing error state from', this.state.errors);
            this.setState({
                errors: nextProps.errorData
            }, ()=>{
                // console.log('%cNEW ERROR STATE IS:','color: greenyellow');
                // console.log(this.state.errors);
            })
        }

        if ((this.props.emailIsVerified !== nextProps.emailIsVerified) && nextProps.emailIsVerified) {
            this.props.notifyUser({
                visible: true,
                message: 'Congratulations, your account has been successfully activated!',
                textColor: 'white'
            })    
            .then((res) => {
                // nextProps.handleClose();
                this.advanceStepper();
                
            })
            .catch(console.log);
        }

        if ((nextProps.userId !== this.props.userId && !!nextProps.userId && nextProps.emailVerified) || (nextProps.emailVerified && this.props.emailVerified !== nextProps.emailVerified)) {
            this.props.notifyUser({
                message: 'Welcome, you are now logged in.',
                textColor: 'white'
            })    
            .then((res) => {
                // nextProps.getClientData(nextProps.userId);
                if(nextProps.emailIsVerified){
                    this.advanceStepper();
                }
            })
            .catch(console.log);
        }
    }
    
    advanceStepper = () => {
        // console.log('Prev Step:', this.state.stepToShow);
        const currentStep = this.state.stepToShow;
        // If this is the final step then close otherwise advance.
        if (this.state.stepToShow !== this.state.finalStep){
            // console.log('not finished yet, advancing...');
            this.setState({
                stepToShow: currentStep + 1
            }, ()=>{
                // console.log('New Step:', this.state.stepToShow);
            })
        } else {
            // console.log('Youre at the last step cant advance closing instead');
            this.handleCloseDialog();
        }
    }
    
    reverseStepper = () => {
        const currentStep = this.state.stepToShow;
        if (currentStep > 0) {
            this.setState({
                stepToShow: currentStep - 1
            });
        }
    }
    
    handleCloseDialog = () => {
        // console.log('%cCLOSING DIALOG...','color: gold');
        this.props.handleClose();
        this.resetBookingDialog();
        this.determineAuthFlowRequirement();
    }

    determineAuthFlowRequirement = () => {
        if (this.props.userId) {
            this.props.endAuthFlowRequiredStatus();
        } else {
            this.props.initAuthFlowRequiredStatus();
        }
    }

    resetBookingDialog = () => {
        // console.log('Running all dialog resets (Stepper, Choice, Values).');
        this.resetStepper();
        this.resetCurrentDialog();
        this.resetFormValues();
    }

    resetStepper = () => {
        this.setState({
            stepToShow: 0
        })
    }

    resetCurrentDialog = () => {
        // console.log('Resetting dialog to login');
        this.props.setCurrentDialog('login');
    }
    
    resetFormValues = () => {
        this.setState({
            formValues: null
        });
        this.props.resetBookingData();
    }

    resetErrors = (reset)=> {
        reset();
        this.setState({
            errors: null
        });
    }
    
    stepperControls = {
        reverseStepper: this.reverseStepper,
        advanceStepper: this.advanceStepper,
        setFinalStep: this.setFinalStep
    }

    setFinalStep = (finalStep) => {
        this.setState({
            finalStep: finalStep
        });
    }

    handleConfirmData = (values) => {
        this.setState({
            formValues: values
        });
        this.advanceStepper();
    }

    getSignUpStep = () => (
        <SignUpStep 
            label="Sign Up" 
            handleClose={this.handleCloseDialog} 
            errors={this.props.errorData} 
            stepperControls={this.stepperControls} 
            resetBookingDialog={this.resetBookingDialog}
            resetErrors={this.resetErrors} 
            handleChooseAuthDialog={this.handleChooseAuthDialog} 
        />
    )

    getLoginStep = () => (
        <LoginStep 
            label="Login"
            handleClose={this.handleCloseDialog}
            errors={this.props.errorData}
            stepperControls={this.stepperControls}
            resetErrors={this.resetErrors}
            resetBookingDialog={this.resetBookingDialog}
            handleChooseAuthDialog={this.handleChooseAuthDialog}
        />
    )
    
    getVerificationStep = () => (
        <VerificationStep 
            label="Verify Account"
            handleClose={this.handleCloseDialog}
            stepperControls={this.stepperControls}
            resetErrors={this.resetErrors}
            resetBookingDialog={this.resetBookingDialog}
            user={this.props.authData} 
        />
    )
    
    getConfirmStep = () => (
        <ConfirmStep 
            label="Confirm Details"
            handleClose={this.handleCloseDialog}
            errors={this.props.errorData}
            stepperControls={this.stepperControls}
            handleConfirmData={(values) => this.props.confirmBookingData(values)
                .then((res) => {
                    this.advanceStepper();
                })
                .catch(console.log
            )}
            clientData={this.props.userData}
            bookingData={this.props.formValues}
            resetErrors={this.resetErrors}
            resetBookingDialog={this.resetBookingDialog}
        />
    )

    getPaymentStep = () => {
        // console.log(`%cHANDLE CONFIRM BOOKING${JSON.stringify(this.props)}`,'color: gold');
        return (
            <PaymentStep 
                label="Complete Payment" 
                handleClose={this.handleCloseDialog} 
                errors={this.props.errorData}
                handleConfirmBooking={this.props.onConfirmBooking}
                bookingData={{...this.state.formValues, ...this.props.data}}
                clientData={this.props.userData}
                stepperControls={this.stepperControls}
                resetBookingDialog={this.resetBookingDialog}
                provider={this.props.provider}
            />
    )}

    getPasswordResetStep = () => (
        <div style={{ marginTop: -10, marginBottom: 10 }}>
            <PasswordResetStep
                handleClose={this.handleCloseDialog}
                errors={this.props.errorData}
                resetErrors={this.resetErrors}
                stepperControls={this.stepperControls}
                handleChooseAuthDialog={this.handleChooseAuthDialog}
                resetBookingDialog={this.resetBookingDialog}
            />
        </div>
    )

    getSignUpAuthFlow = () => {
        return (
                <AuthStepper
                    isAuthenticated={!!this.props.authData}
                    step={this.state.stepToShow}
                    advanceStepper={this.advanceStepper}
                    reverseStepper={this.reverseStepper}
                    resetStepper={this.resetStepper}
                    setFinalStep={this.setFinalStep}
                >
                    { this.getSignUpStep() }
                    { this.getVerificationStep() }
                    { this.getConfirmStep() }
                    { this.getPaymentStep() }
                </AuthStepper>
        );
    }

    render() {
        const { authData } = this.props;
        // const { provider, bookingTime, bookingDate } = data;
        // const { currentDialog } = this.state;
        // console.log('PROVIDER @ booking flow', this.props.provider);
          return (
            <div>
                { this.props.currentDialog === 'signup' && this.props.authFlowRequired &&
                    <div>{ this.getSignUpAuthFlow() }</div>
                }
                {this.props.currentDialog === 'login' && this.props.authFlowRequired &&
                    <AuthStepper
                        isAuthenticated={!!authData}
                        step={this.state.stepToShow}
                        advanceStepper={this.advanceStepper}
                        reverseStepper={this.reverseStepper}
                        resetStepper={this.resetStepper}
                        setFinalStep={this.setFinalStep}
                    >
                        { this.getLoginStep() }
                        { this.getConfirmStep() }
                        { this.getPaymentStep() }
                    </AuthStepper>
                }
                { this.props.currentDialog === 'reset' && this.props.authFlowRequired &&
                        <div style={{ display: 'block', margin: '0 auto', maxWidth: 650  }}>{ this.getPasswordResetStep() }</div>
                }
                { !this.props.authFlowRequired &&
                    <AuthStepper
                        isAuthenticated={!!authData}
                        step={this.state.stepToShow}
                        advanceStepper={this.advanceStepper}
                        reverseStepper={this.reverseStepper}
                        resetStepper={this.resetStepper}
                        setFinalStep={this.setFinalStep}
                    >
                        { this.getConfirmStep() }
                        { this.getPaymentStep() }
                    </AuthStepper>
                }
            </div>
          );
    }
  }

  const mapStateToProps = ({auth, dialog, client, payment, form}) => {
    // console.log('%cSERVER ERROR @ MSTP','color: greenyellow');
    // console.log(auth.serverError);
    // console.log('CLIENT DATA @ MSTP', client.userData);
    return {
        authFlowRequired: auth.isAuthFlow,
        userData: client.clientData,
        creditAmount: payment.credits,
        currentDialog: dialog.current,
        emailIsVerified: auth.verificationStatus,
        emailVerified: auth.authData.emailVerified,
        errorData: auth.serverError,
        formValues: form.formValues,
        passwordData: auth.passwordData,
        userId: (auth.authData) ? auth.authData.id : null,
        userEmail: (auth.authData) ? auth.authData.email : null,
        authData: auth.authData,
    };
  }

  export default connect(mapStateToProps, actions)(BookingFlowScreen);

  /*
  
  open 
  handleClose
  
  */


// WEBPACK FOOTER //
// ./src/js/components/Dialog/BookingFlowScreen.jsx